// extracted by mini-css-extract-plugin
export default {"cards":"Cards_cards__aQ6-f","iconBox":"Cards_iconBox__5kBD2","description":"Cards_description__7uze2","left":"Cards_left__GZnc0"};